import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'DialogConfirmTransferOwnership',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    plantName: {
      type: String,
      required: true,
    },
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
    },
  },
  emits: ['hide-dialog', 'confirm'],
})
export default class DialogConfirmTransferOwnership extends Vue {
  isVisible!: boolean;
  isDialogVisible = false;
  password = '';

  get isConfirmDisabled() {
    return !this.password;
  }

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;

    this.$nextTick(() => {
      this.password = '';
    });
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  doConfirm() {
    this.$emit('confirm', this.password);
    this.handleHideDialog();
  }
}
